(function () {
  'use strict';

  function isProtectedImage(target) {
    return target && target.tagName === 'IMG' && !target.hasAttribute('data-allow-save');
  }

  document.addEventListener('contextmenu', function (e) {
    if (isProtectedImage(e.target)) e.preventDefault();
  });

  document.addEventListener('dragstart', function (e) {
    if (isProtectedImage(e.target)) e.preventDefault();
  });
})();
